module.exports = __webpack_public_path__ + "static/img/4.3cda711.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/4.png
// module id = rU2U
// module chunks = 0